var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"}),_c('div',{staticClass:"col-sm-2"},[_c('CustomSelect',{attrs:{"name":"filterBy","placeholder":"Filter By","optionLabel":'name',"options":_vm.providerStatFilter},model:{value:(_vm.filterBy),callback:function ($$v) {_vm.filterBy=$$v},expression:"filterBy"}})],1)]),_c('div',[_c('apexchart',{attrs:{"height":"400","width":"1400","type":"bar","options":{
        plotOptions: {
          bar: {
            borderRadius: 0,
          },
        },
      },"series":[
          {
            data: _vm.chartData.map((dt) => ({
              x: dt.log_date,
              y: dt.log_count,
            })),
          },
      ]}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }